<template>
  <div class="sticky">
    <div ref="wrapper" class="thin-button-wrapper" :class="{'shadow-lg': showShadow && expandedData} ">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThinButtonWrapper",
  emits: ['buttons-loaded'],
  props: {
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    showShadow: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  watch: {
    expanded() {
      this.expandedData = this.expanded;
      this.onExpandedPropChange();
    }
  },
  data() {
    return {
      expandedData: false,
      buttons: {
        validator(value) {
          return (value instanceof HTMLCollection);
        }
      }
    }
  },
  mounted() {
    let wrapper = this.$refs.wrapper;
    wrapper.addEventListener('mouseover', () => this.onButtonHover());
    wrapper.addEventListener('mouseout', () => this.onButtonHoverStop());

    this.initializeButtons(wrapper);
    if (this.buttons.length) {
      this.$emit('buttons-loaded');
    }

    const config = {
      childList: true,
      subtree: true
    };
    // Wait for the buttons with an mutation observer
    const observer = new MutationObserver(() => {
      this.initializeButtons(wrapper);
    });

    observer.observe(wrapper, config);
  },
  methods: {
    initializeButtons(wrapper) {
      this.buttons = [...wrapper.getElementsByClassName('rounded-button')];
      if (!this.buttons.length) return;
      this.$emit('buttons-loaded');
      for(let btn of this.buttons) {
        btn.classList.add('thin-wrapper-button');
      }
      this.onExpandedPropChange();
    },
    onExpandedPropChange() {
      if (this.expanded) {
        this.displayButtons();
      }
      else {
        this.hideButtons();
      }
    },
    onButtonHoverStop() {
      // If expanded prop is true we want to override and not stop expanding if we stop hovering.
      if(this.expanded) return;
      this.hideButtons()
    },
    hideButtons() {
      this.expandedData = false;
      for(let btn of this.buttons) {
        this.hideText(btn);
      }
    },
    onButtonHover() {
      this.displayButtons();
    },
    displayButtons() {
      this.expandedData = true;
      for(let btn of this.buttons) {
        this.showText(btn);
      }
    },
    hideText(btn) {
      btn.classList.add('hide-text');
    },
    showText(btn) {
      btn.classList.remove('hide-text');
    }
  }
}
</script>
<style lang="scss">
@import "~@/_default.scss";
.thin-button-wrapper {
  button.thin-wrapper-button {
    width: 220px;
    overflow: clip;
    position: relative;
    span {
      white-space: nowrap;
    }
  }

  button.thin-wrapper-button.hide-text {
    width: $spacing-xl;
  }
}

</style>
<style lang="scss" scoped>
@import "~@/_default.scss";

.thin-button-wrapper {
  background-color:  $main-content-bg-color;
  display: flex;
  flex-direction: column;
  row-gap: $spacing-sm;
  padding-left: $spacing-lg;
  padding-top: $spacing-lg;
  padding-right: $spacing-xxl;
  position: absolute;
  height: 100vh;
  top: 0;
  bottom: 0;
  right: 0;
}

.sticky {
  position: sticky;
  height: 1px;
  top: $navbar-height;
}
</style>
